import { useState } from 'react';
import { Button } from '../../ui/Button';
import { authClient } from './authClient';

/**
 * Starts Google sign-in. On a refusal Better Auth sends the browser back to `errorPath` with
 * `?error=<code>`. URLs are absolute on this origin so local dev (Vite on :5173) comes back to the
 * dev server rather than to the Worker's own origin.
 */
export function GoogleButton({ errorPath }: { errorPath: string }) {
  const [busy, setBusy] = useState(false);
  return (
    <Button
      block
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          const origin = window.location.origin;
          await authClient.signIn.social({
            provider: 'google',
            callbackURL: `${origin}/`,
            errorCallbackURL: `${origin}${errorPath}`,
          });
        } finally {
          setBusy(false);
        }
      }}
    >
      Continue with Google
    </Button>
  );
}
